/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ChangeConfigurationTask
 */
export interface ChangeConfigurationTask {
    /**
     *
     * @type {string}
     * @memberof ChangeConfigurationTask
     */
    key?: string;
    /**
     *
     * @type {string}
     * @memberof ChangeConfigurationTask
     */
    value?: string;
}

/**
 * Check if a given object implements the ChangeConfigurationTask interface.
 */
export function instanceOfChangeConfigurationTask(
    value: object,
): value is ChangeConfigurationTask {
    return true;
}

export function ChangeConfigurationTaskFromJSON(
    json: any,
): ChangeConfigurationTask {
    return ChangeConfigurationTaskFromJSONTyped(json, false);
}

export function ChangeConfigurationTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ChangeConfigurationTask {
    if (json == null) {
        return json;
    }
    return {
        key: json["key"] == null ? undefined : json["key"],
        value: json["value"] == null ? undefined : json["value"],
    };
}

export function ChangeConfigurationTaskToJSON(
    value?: ChangeConfigurationTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        key: value["key"],
        value: value["value"],
    };
}
